/* global H264 */
// eslint-disable-next-line no-global-assign
H264 = module.exports = {}
H264.NAL_TYPES = ['NONE', 'P', 'DATAA', 'DATAB', 'DATAC', 'I', 'SEI', 'SPS', 'PPS', 'AUD', 'EOSEQUENCE', 'EOSTREAM', 'FILLER', 'SPSEXT', 'PREFIX', 'SUBSETSPS', 'RESERVED1', 'RESERVED2', 'RESERVED3', 'AUX', 'EXT', 'EXTDPV', 'RESERVED4', 'RESERVED5', '24', '25', '26', '27', '28', '29', '30', '31']
H264.NAL = Object.fromEntries(H264.NAL_TYPES.map((v, i)=>[v, i]))
H264.NAL_TYPE_FU_A_FRAGMENTATION_UNIT = 28

const SPS_PROFILE_NAMES = { // https://en.wikipedia.org/wiki/Advanced_Video_Coding
  66: 'Baseline',
  88: 'Extended',
  77: 'Main',
  100: 'High',
  110: 'High 10',
  122: 'High 4:2:2',
  244: 'High 4:4:4',
  44: 'CAVLC 4:4:4 Intra',
  83: 'Scalable Baseline',
  86: 'Scalable High',
  128: 'Stereo High',
  118: 'Multiview High',
  134: 'MFC High',
  135: 'MFC Depth High',
  138: 'Multiview Depth High Profile',
  139: 'Enhanced Multiview Depth High',
}

H264.getUint = function(buf) {
  if(!buf) return
  if(typeof Buffer==='function' && buf instanceof Buffer) {
    return new Uint8Array(buf.buffer.slice(buf.byteOffset, buf.byteOffset+buf.length))
  }else if(buf instanceof ArrayBuffer) {
    return new Uint8Array(buf)
  }else if(buf instanceof DataView) {
    return new Uint8Array(buf.buffer.slice(buf.byteOffset, buf.byteLength))
  }else if(ArrayBuffer.isView(buf)) {
    return new Uint8Array(buf)
  }
} // getUint

H264.parseSPS = function(sps_hex) {
  function readBits(num) {
    return parseInt(bits.splice(0, num).join(''), 2)
  } // readBits

  function readExpGolomb() {
    let cnt = 0
    while(!bits[cnt]) cnt++
    const value_bits = bits.slice(cnt, cnt*2+1)
    bits = bits.slice(cnt*2+1)
    return parseInt(value_bits.join(''), 2)-1
  }

  function skipScalingList(count) {
    const seq_scaling_list_present_flags = readBits(1)
    if(!seq_scaling_list_present_flags) return
    let lastScale = 8; let nextScale = 8; let deltaScale
    for(let j=0; j<count; j++) {
      if(nextScale) {
        deltaScale = readExpGolomb()
        nextScale = (lastScale + deltaScale + 256) % 256
      }
      lastScale = nextScale || lastScale
    }
  }

  const uint = H264.getUint(sps_hex)

  // here must be var as it is used in readBits, readExpGolomb, skipScalingList functions above
  // eslint-disable-next-line no-var
  var bits =
    uint ? Array.from(uint).map(x=>parseInt(x).toString(2).padStart(8, '0')).join('').split('').map(x=>parseInt(x)) :
      typeof (sps_hex)==='string' ? sps_hex.match(/(..)/g).map(x=>parseInt(x, 16).toString(2).padStart(8, '0')).join('').split('').map(x=>parseInt(x)) :
        []
  if(bits.length===0) return

  const sps = {
    frameCropLeftOffset: 0,
    frameCropRightOffset: 0,
    frameCropTopOffset: 0,
    frameCropBottomOffset: 0,
    sarScale: 1,
  }

  sps.header = readBits(8)
  sps.profileIdc = readBits(8)
  sps.profileCompat = readBits(5)
  readBits(3)
  sps.levelIdc = readBits(8)
  sps.seq_parameter_set_id = readExpGolomb()
  if([44, 83, 86, 100, 110, 118, 122, 128, 244].indexOf(sps.profileIdc)>=0) {
    // some profiles have more optional data we don't need
    sps.chromaFormatIdc = readExpGolomb()
    if(sps.chromaFormatIdc === 3) readBits(1) // separate_colour_plane_flag
    sps.bit_depth_luma_minus8 = readExpGolomb()
    sps.bit_depth_chroma_minus8 = readExpGolomb()
    sps.qpprime_y_zero_transform_bypass_flag = readBits(1)
    sps.seq_scaling_matrix_present_flag = readBits(1)
    if(sps.seq_scaling_matrix_present_flag) {
      sps.scalingListCount = sps.chromaFormatIdc===3 ? 12 : 8
      for(let i=0; i<sps.scalingListCount; i++) {
        skipScalingList(i<6 ? 16 : 64)
      }
    }
  }
  sps.log2_max_frame_num_minus4 = readExpGolomb()
  sps.picOrderCntType = readExpGolomb()
  if(sps.picOrderCntType===0) {
    sps.log2_max_pic_order_cnt_lsb_minus4 = readExpGolomb()
  }else if(sps.picOrderCntType===1) {
    sps.delta_pic_order_always_zero_flag = readBits(1)
    sps.offset_for_non_ref_pic = readExpGolomb()
    sps.offset_for_top_to_bottom_field = readExpGolomb()
    sps.numRefFramesInPicOrderCntCycle = readExpGolomb()
    for(let i = 0; i<sps.numRefFramesInPicOrderCntCycle; i++) readExpGolomb() // offset_for_ref_frame[i]
  }
  sps.max_num_ref_frames = readExpGolomb()
  sps.gaps_in_frame_num_value_allowed_flag = readBits(1)
  sps.picWidthInMbsMinus1 = readExpGolomb()
  sps.picHeightInMapUnitsMinus1 = readExpGolomb()
  sps.frameMbsOnlyFlag = readBits(1)
  if(!sps.frameMbsOnlyFlag) sps.mb_adaptive_frame_field_flag = readBits(1)
  sps.direct_8x8_inference_flag = readBits(1)
  sps.frame_cropping_flag = readBits(1)
  if(sps.frame_cropping_flag) {
    sps.frameCropLeftOffset = readExpGolomb()
    sps.frameCropRightOffset = readExpGolomb()
    sps.frameCropTopOffset = readExpGolomb()
    sps.frameCropBottomOffset = readExpGolomb()
  }
  sps.vui_parameters_present_flag = readBits(1)
  if(sps.vui_parameters_present_flag) {
    sps.aspect_ratio_info_present_flag = readBits(1)
    if(sps.aspect_ratio_info_present_flag) {
      sps.aspectRatioIdc = readBits(8)
      const RATIOS = [null, [1, 1], [12, 11], [10, 11], [16, 11], [40, 33], [24, 11], [20, 11], [32, 11], [80, 33], [18, 11], [15, 11], [64, 33], [160, 99], [4, 3], [3, 2], [2, 1]]
      sps.sarRatio = RATIOS[sps.aspectRatioIdc]
      if(sps.aspectRatioIdc===255) sps.sarRatio = [readBits(16), readBits(16)]
      if(sps.sarRatio) sps.sarScale = sps.sarRatio[0] / sps.sarRatio[1]
    }
  }
  sps.width = Math.ceil((((sps.picWidthInMbsMinus1 + 1) * 16) - sps.frameCropLeftOffset * 2 - sps.frameCropRightOffset * 2) * sps.sarScale)
  sps.height = ((2 - sps.frameMbsOnlyFlag) * (sps.picHeightInMapUnitsMinus1 + 1) * 16) - ((sps.frameMbsOnlyFlag? 2 : 4) * (sps.frameCropTopOffset + sps.frameCropBottomOffset))
  sps.profile = SPS_PROFILE_NAMES[sps.profileIdc] || ''
  sps.level = Math.floor(sps.levelIdc / 10) + '.' + (sps.levelIdc % 10)
  return sps
} // parseSPS

H264.splitNALs = function(uint, keep_annex, max_frames, skip_frames) {
  const nals = []
  let start = 0
  const end = uint.length
  let p = 0
  let frames = 0
  skip_frames = skip_frames>0?skip_frames:0
  while(1) {
    if(p===end || (p+2<end && uint[p]===0 && uint[p+1]===0 && (uint[p+2]===1 || (p+3<end && uint[p+2]===0 && uint[p+3]===1)))) {
      // found start of next NAL or end of file; extract NAL if there is enough bytes
      if(p>start+3) {
        const annex_length = uint[start+2]===1 ? 3 : 4
        const nal_type = uint[start+annex_length] & 0b11111
        if(nal_type===H264.NAL.I_FRAME || nal_type===H264.NAL.P_FRAME) {
          frames++
          if(frames>skip_frames) nals.push(uint.subarray(start+(keep_annex?0:annex_length), p))
          if(max_frames>0 && frames>=max_frames) break
        }else{
          nals.push(uint.subarray(start+(keep_annex?0:annex_length), p))
        }
      }
      if(p===end) {
        break
      }else{
        start = p
        p = start + (uint[p+2]===1 ? 3 : 4)
      }
    }else{
      p++
    }
  }
  return nals
} // splitNALs

H264.getNALType = function(buf) {
  let uint = H264.getUint(buf)
  if(!uint) {
    const nal_header = parseInt(buf)
    if(nal_header>0) uint = new Uint8Array([nal_header])
  }
  if(!uint || uint.byteLength<1) return

  if(uint.byteLength>=4 && uint[0]===0 && uint[1]===0) {
    if(uint[2]===1) {
      uint=uint.subarray(3)
    }else if(uint.byteLength>=5 && uint[2]===0 && uint[3]===1) {
      uint=uint.subarray(4)
    }
  }

  let nal_type = uint[0] & 0b11111
  if(nal_type===H264.NAL_TYPE_FU_A_FRAGMENTATION_UNIT) {
    if(uint.byteLength<2) return
    const fu_header = uint[1]
    nal_type = fu_header & 0b11111
  }
  return nal_type
} // getNALType

H264.getNALTypeName = function(buf) {
  return H264.NAL_TYPES[H264.getNALType(buf)]
} // getNALTypeName

H264.isFrame = function(buf) {
  const nal_type = H264.getNALType(buf)
  return (nal_type===H264.NAL.I || nal_type===H264.NAL.P) ? 1 : 0
} // isFrame
